/* eslint-disable no-extend-native */

String.prototype.hashCode = function() {
  return 'id' + Array.from(this)
    .reduce((s, c) => Math.imul(31, s) + c.charCodeAt(0) || 0, 0)
    .toString()
    .replace('-', '');
};

String.prototype.toDate = function() {
  return new Date(this as string);
};

interface Date {
  toLocalDateString(): string;
}

Date.prototype.toLocalDateString = function() {
  const date = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()));
  return `${date.toISOString().split('T')[0]}T00:00:00`;
};

interface String {
  hashCode(): string;
  toDate(): Date;
}
